<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>
<app-header></app-header>
<app-botao-chat></app-botao-chat>
<app-alert-erro-padrao [showAlertaErro]="showAlertErro"
  (alertErroPadraoFechou)="alertaErroFechou()"
  [descricaoErro]="descricaoErro"
></app-alert-erro-padrao>
<app-alert-atencao-padrao (alertaCancelou)="alertaAtencaoAtualizacaoFechou()"
  (alertaConfirmou)="confirmouAtualizacao()"
  [descricaoAlerta]="descricaoAlertaAtualizacao"
  [tituloAlerta]="tituloAlertaAtualizacao"
  [showAlerta]="showAlertConcluirAtualizacao">
</app-alert-atencao-padrao>
<app-alert-descartar-alteracoes [show]="showAlertDescarte"
  (confirmouDescarte)="cancelarAlteracoes($event)"
  (cancelouDescarte)="manterAlteracoes($event)">

</app-alert-descartar-alteracoes>
<app-alert-sucesso-padrao (alertSucessoFechou)="sucessoFechou()"
  [descricaoSucesso]="descricaoSucesso"
  [showSucesso]="alertSucesso">
</app-alert-sucesso-padrao>
<div class="container py-4">
  <!-- CONTEÚDO -->
  <div class="row">
    <div class="col-12 col-lg-8 mb-4 mb-lg-0">
      <div class="card-importacao">
        <app-breadcrumb></app-breadcrumb>
        <div class="div-titulo-pagina">
          <h1>Importar Dados Bancários</h1>
          <h2>Ferramenta para importar dados da folha de pagamento</h2>
        </div>

        <!-- Importador de arquivos, a parte que vai escolher o arquivo -->
        <app-file-upload-area
          cssClass="file-drop-area"
          [nomeArquivo]="nomeArquivo"
          [processandoDados]="processandoDados"
          [listaExtensoes]="listaExtensoes"
          [dataHoje]="dataHoje"
          (arquivoCapturado)="capturarArquivo($event)"
          (arquivoLimpo)="limpaArquivoSelecionado()">
        </app-file-upload-area>
        <div class="div-botoes-arquivo">
          <button class="botao-outline" id="btnCancelarEnvio" [disabled]="!checkArquivo || processandoDados"
                  (click)="cancelarCapturaArquivo()" [ngClass]="{
                            'cancelar-arquivo-disabled': !checkArquivo || processandoDados}">CANCELAR
          </button>
          <!-- Estou mandando para pagina de concluir direto enquanto nao tem API -->
          <button class="botao-enviar-arquivo" id="btnEnviar" (click)='enviarDadosVerificar()' [disabled]="!checkArquivo || processandoDados"
                  [ngClass]="{
                            'enviar-arquivo-disabled': !checkArquivo || processandoDados || !('FerramentasImportacoes' | usuarioPermissao:'Incluir' | async)
                          }">ENVIAR
          </button>
        </div>
      </div>
    </div>
    <!-- DIV LATERAL COM  INFORMAÇÕES -->
    <div class="d-none d-lg-block col-lg-4">
      <div class="card-orientacao">
        <h1>ORIENTAÇÕES IMPORTANTES</h1>
        <p>Ferramenta exclusiva para importação de dados bancários para usuários já cadastrados.</p>
        <button class="gerar-arquivo-pdf" id="btnGerarArquivoPDF" (click)='pdf()' (click)='getArquivo()'>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M1.99999 10C2.36818 10 2.66666 10.2985 2.66666 10.6667V12C2.66666 12.7364 3.26362 13.3333 4 13.3333H12C12.7364 13.3333 13.3333 12.7364 13.3333 12V10.6667C13.3333 10.2985 13.6318 10 14 10C14.3682 10 14.6667 10.2985 14.6667 10.6667V12C14.6667 13.4728 13.4728 14.6667 12 14.6667H4C2.52724 14.6667 1.33333 13.4728 1.33333 12V10.6667C1.33333 10.2985 1.63181 10 1.99999 10Z"
              fill="#008060"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M7.99999 10.6666C7.6318 10.6666 7.33333 10.3681 7.33333 9.99996L7.33333 1.99996C7.33333 1.63177 7.63181 1.33329 8 1.33329C8.36818 1.33329 8.66666 1.63177 8.66666 1.99996L8.66666 9.99996C8.66666 10.3681 8.36818 10.6666 7.99999 10.6666Z"
              fill="#008060"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M4.19526 6.19526C3.93491 6.45561 3.93491 6.87772 4.19526 7.13807L7.5286 10.4714C7.78894 10.7318 8.21106 10.7318 8.4714 10.4714L11.8047 7.13807C12.0651 6.87772 12.0651 6.45561 11.8047 6.19526C11.5444 5.93491 11.1223 5.93491 10.8619 6.19526L8 9.05719L5.13807 6.19526C4.87772 5.93491 4.45561 5.93491 4.19526 6.19526Z"
              fill="#008060"/>
          </svg>
          GUIA PARA GERAR ARQUIVO PDF
        </button>
        <h2>Instruções para a importação dos dados bancários dos usuários usando arquivo texto.</h2>
        <button class="gerar-arquivo-xls" id="btnGerarArquivoXLS" (click)='xls()' (click)='getArquivo()'>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M1.99999 10C2.36818 10 2.66666 10.2985 2.66666 10.6667V12C2.66666 12.7364 3.26362 13.3333 4 13.3333H12C12.7364 13.3333 13.3333 12.7364 13.3333 12V10.6667C13.3333 10.2985 13.6318 10 14 10C14.3682 10 14.6667 10.2985 14.6667 10.6667V12C14.6667 13.4728 13.4728 14.6667 12 14.6667H4C2.52724 14.6667 1.33333 13.4728 1.33333 12V10.6667C1.33333 10.2985 1.63181 10 1.99999 10Z"
              fill="#008060"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M7.99999 10.6666C7.6318 10.6666 7.33333 10.3681 7.33333 9.99996L7.33333 1.99996C7.33333 1.63177 7.63181 1.33329 8 1.33329C8.36818 1.33329 8.66666 1.63177 8.66666 1.99996L8.66666 9.99996C8.66666 10.3681 8.36818 10.6666 7.99999 10.6666Z"
              fill="#008060"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M4.19526 6.19526C3.93491 6.45561 3.93491 6.87772 4.19526 7.13807L7.5286 10.4714C7.78894 10.7318 8.21106 10.7318 8.4714 10.4714L11.8047 7.13807C12.0651 6.87772 12.0651 6.45561 11.8047 6.19526C11.5444 5.93491 11.1223 5.93491 10.8619 6.19526L8 9.05719L5.13807 6.19526C4.87772 5.93491 4.45561 5.93491 4.19526 6.19526Z"
              fill="#008060"/>
          </svg>
          MODELO DE ARQUIVO XLS
        </button>
        <h2>Use esse modelo de planilha do Excel para importação dos dados bancários dos usuários.</h2>

      </div>
    </div>

    <!-- ÚLTIMAS IMPORTAÇÕES TABELA -->
    <div class="col-12 mt-3 ultimas-importacoes">
      <div class="card">
        <h3 class="titulo-ultimas-importacoes">Últimas importações de dados bancários</h3>
        <h4 class="paragrafo-card mb-3">Dados das últimas importações realizadas</h4>

        @if (naoTemRegistro) {
          <div class="text-center">
            <img src="/assets/img/vazio.png" alt="sem historico de importações." width="200px">
            <p>Empresa sem histórico de importações.</p>
          </div>
        }

        @if (!naoTemRegistro) {
          <!-- TABELA -->
          <table class="table table-hover"
            aria-describedby="tabela com dados das ocorrencias">
            <thead>
              <tr>
                <th scope="col">DATA</th>
                <th scope="col">HORÁRIO</th>
                <th scope="col">FASE</th>
                <th scope="col">TIPO DO ARQUIVO</th>
                <th scope="col">SITUAÇÃO</th>
                <th scope="col">MENSAGEM</th>
              </tr>
            </thead>
            <tbody>
              <!-- LINHA 1 -->
              @for (o of resources | paginate: { id: 'importarDadosBancarios', itemsPerPage: pagination.pageSize , currentPage: pagination.currentPagePaginator, totalItems: pagination.totalElements}; track o) {
                <tr
                  >
                  <td>{{o.dataImportacao | date:'dd/MM/yyyy' : 'UTC'}}</td>
                  <td>{{o.dataImportacao | date:'H:mm:ss' : 'UTC' }}</td>
                  <td>{{o.dsCodFasImp}}</td>
                  <td>{{o.dsTipArqIma}}</td>
                  <td>{{o.dsStatusImp}}</td>
                  <td>{{o.dsMsgWarImp}}</td>
                </tr>
              }
            </tbody>
          </table>
        }
        @if (totalRegistros>0) {
          <div class="paginacao-padding">
            <div
              style="display: flex; margin-left: 25px"
              class="exibicao-paginacao"
              >
              <span><p>Exibir</p></span>
              <div class="select-registros-importar" style="margin-top: 6px !important;">
                <app-select
                  ngClass="form-control-selecao select-registros-importar"
                  [value]="pagination.pageSize"
                  (valueChanges)="pagination.pageSize = $event"
                  (change)="getApiData()"
                  name="itensPorPaginaImporta"
                  id="itensPorPaginaImporta"
                                [options]="[
                                  { name: '5 REGISTROS', value: '5' },
                                  { name: '10 REGISTROS', value: '10' },
                                  { name: '50 REGISTROS', value: '50' }
                                ]"
                  optionValue="value"
                  optionText="name"
                  >
                </app-select>
                <i class="fa fa-caret-down c-primary" aria-hidden="true"></i>
              </div>
              <span><p>por página</p></span>
            </div>
            <div class="paginacao-centro-padding">
              <pagination-controls
                id="importarDadosBancarios"
                (pageChange)="getPage($event)"
                (pageBoundsCorrection)="pageChanged($event)"
                directionLinks="false"
                autoHide="false"
                responsive="true"
                previousLabel=""
                nextLabel=""
                screenReaderPaginationLabel="pagination"
                screenReaderPageLabel="page"
                screenReaderCurrentLabel="Página"
                >
              </pagination-controls>
            </div>
            <div class="paginacao-direita-padding">
              <div class="row" style="justify-content: right; margin-right: 5px !important; margin-bottom: 5px;">
                <span class="subtitulo-table"
                  ><p>
                  <b style="font-weight: 600">{{ totalRegistros }}</b> Registros
                  foram encontrados
                </p></span
                >
              </div>
            </div>
          </div>
        }

      </div>

    </div>

  </div>
</div>

<app-footer></app-footer>
